import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheFutureOfYourFrontDesk from "./sections/TheFutureOfYourFrontDesk";
import WhoWeHelp from "./sections/WhoWeHelp";
import TailoredDigitalSolutions from "./sections/TailoredDigitalSolutions";
import OurApproach from "./sections/OurApproach";
import PracticalOutcomes from "./sections/PracticalOutcomes";
import StrategicInsights from "./sections/StrategicInsights";
import ProvenTrackRecord from "./sections/ProvenTrackRecord";
import SecureYourSlot from "./sections/SecureYourSlot";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheFutureOfYourFrontDesk />
      <WhoWeHelp />
      <TailoredDigitalSolutions />
      <OurApproach />
      <PracticalOutcomes />
      <StrategicInsights />
      <ProvenTrackRecord />
      <SecureYourSlot />
      <Footer />
    </div>;
}